import { ROUTES } from "@config/app.routing";

import { Icon, IconVariant } from "@ui/Assets/Symbolicons/Symbolicons";
import theme from "@ui/themes/default";

export const disabledIconStyle = {
  size: theme.icons.sizes.base_x4,
  width: theme.icons.sizes.base_x3,
  color: theme.palette.grey100,
  variant: "line" as IconVariant,
};

export const inactiveIconStyle = {
  size: theme.icons.sizes.base_x4,
  width: theme.icons.sizes.base_x3,
  color: theme.palette.grey400,
  variant: "line" as IconVariant,
};

export const activeIconStyle = {
  size: theme.icons.sizes.base_x4,
  width: theme.icons.sizes.base_x3,
  color: theme.palette.grey800,
  variant: "solid" as IconVariant,
};

export const getIconStyle = (isActive?: boolean): Icon =>
  isActive ? activeIconStyle : inactiveIconStyle;

export const MY_CLEANINGS_ROUTE = `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_MY_CLEANINGS}`;
export const BOOKINGS_TO_VALIDATE_ROUTE = `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_BOOKINGS_TO_VALIDATE}`;
export const SUPPORT_ROUTE = ROUTES.SUPPORT;
export const PROFILE_ROUTE = `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_PROFILE}`;
export const OPTIONS_ROUTE = `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_OPTIONS}`;

export const ACTIVE_BOOKING_BTN_ROUTES: string[] = [
  ROUTES.BASE,
  ROUTES.BOOKING,
  ROUTES.BOOKING_CHECKOUT,
  ROUTES.END_OF_TENANCY,
  ROUTES.END_OF_TENANCY_CHECKOUT,
];
export const ACTIVE_MY_CLEANINGS_BTN_ROUTES: string[] = [
  MY_CLEANINGS_ROUTE,
  BOOKINGS_TO_VALIDATE_ROUTE,
];

export const ROUTES_WITHOUT_BOTTOM_NAVIGATION: string[] = [
  ROUTES.APPLY,
  ROUTES.APPLY_PERSONAL_INFO,
  ROUTES.APPLY_EXPERIENCE_INFO,
  ROUTES.THANK_YOU_PAGE,
  ROUTES.BOOKING,
  ROUTES.BOOKING_CHECKOUT,
  ROUTES.B2B,
  ROUTES.B2B_CHECKOUT,
  ROUTES.END_OF_TENANCY,
  ROUTES.END_OF_TENANCY_CHECKOUT,
  ROUTES.CLIENT_CHECKLIST,
  `${ROUTES.GIFT_CARDS}${ROUTES.GIFT_CARDS_BUY}`,
  `${ROUTES.GIFT_CARDS}${ROUTES.GIFT_CARDS_THANK_YOU}`,
];

export const ROUTES_WITH_PARAMS_WITHOUT_BOTTOM_NAVIGATION: string[] = [];
